<div id="predictor-button-bar"
  class="basin-overflow-x-auto basin-background-darkest-gray basin-width-100 basin-height-100 basin-display-flex basin-align-items-center basin-py-3">
  <div class="button-container basin-display-flex basin-align-items-center basin-justify-content-center basin-px-4">
    <p-splitButton [label]="paintSplitLabel" (onClick)="toggleCurrentSplitAction()" [model]="paintSplitItems"
      class="button-bar-button" [styleClass]="buttonBarWidth < 1540 ? 'p-button-sm' : ''" appendTo="body" [disabled]="
        (showCanvas$ | async) === false ||
        canvasService.canvasConfigured === false ||
        (terrainRendered$ | async) === false ||
        simulating||((scenarios$ | async)?.length ?? 0) > 0
      "></p-splitButton>
    <p-divider layout="vertical" class="basin-height-100"></p-divider>
    <button pButton icon="symbol-skip-previous" label="Reset" (click)="reset()" class="basin-mr-3 button-bar-button"
      [class.p-button-sm]="buttonBarWidth < 1540"
      [disabled]="(showCanvas$ | async) === false || resetDisabled() || ((scenarios$ | async)?.length ?? 0) > 0 || (simulationService.simulationState !== 'completed')"></button>
    <button pButton [icon]="shouldDisplayGo() ? 'symbol-play-arrow' : 'symbol-pause'"
      [label]="shouldDisplayGo() ? 'Go' : 'Pause'" (click)="go()" class="basin-mr-3 button-bar-button"
      [class.p-button-sm]="buttonBarWidth < 1540" [disabled]="
        (showCanvas$ | async) === false ||
        canvasService.canvasConfigured === false ||
        canvasService.agents.length === 0 ||
        completedRender() ||
        simulationLoopService.isLooping() ||
        finishing || ((scenarios$ | async)?.length ?? 0) > 0
      "></button>
    <button pButton icon="symbol-fast-forward" label="Step" (click)="nextStep()" class="basin-mr-3 button-bar-button"
      [class.p-button-sm]="buttonBarWidth < 1540" [disabled]="
        (showCanvas$ | async) === false ||
        !eanbleFinish() ||
        finishing ||((scenarios$ | async)?.length ?? 0) > 0
      "></button>
    <button pButton icon="symbol-skip-next" label="Finish" (click)="finish()" class="basin-mr-3 button-bar-button"
      [class.p-button-sm]="buttonBarWidth < 1540" [disabled]="
        (showCanvas$ | async) === false ||
        !eanbleFinish() ||
        finishing || ((((scenarios$ | async)?.length ?? 0) > 0))
      "></button>

    <button pButton icon="icon-clear" label="Clear" class="button-bar-button" (click)="confirmClear($event)"
      [class.p-button-sm]="buttonBarWidth < 1540" [disabled]="
        (showCanvas$ | async) === false || !enableClearButton() || finishing
      "></button>

    <p-divider layout="vertical" class="basin-height-100"></p-divider>

    <button #loopButton pButton icon="symbol-loop" label="Loop" (click)="openLoopModal()" class="button-bar-button"
      [class.p-button-sm]="buttonBarWidth < 1540" [disabled]="(showCanvas$ | async) === false || loopDisabled()"
      *ngIf="!simulationLoopService.isLooping()"></button>

    <button pButton icon="icon-clear" label="Kill" class="button-bar-button" (click)="killLoop()"
      [class.p-button-sm]="buttonBarWidth < 1540" *ngIf="simulationLoopService.isLooping()" [disabled]="
        (showCanvas$ | async) === false || canvasService.canvasConfigured === false
      "></button>

    <p-divider layout="vertical" class="basin-height-100"></p-divider>

    <button pButton icon="symbol-center-focus-weak" [label]="(showDetails$ | async) ? 'Exit Inspect' : 'Inspect'"
      (click)="toggleDetails()" class="button-bar-button" [class.p-button-sm]="buttonBarWidth < 1540"
      [disabled]="(showCanvas$ | async) === false || (terrainRendered$ | async) === false || processing || (((scenarios$ | async)?.length ?? 0) > 0)"></button>

  </div>
</div>
<p-confirmDialog header="Confirmation"></p-confirmDialog>